import { render, staticRenderFns } from "./ProxyErrors.vue?vue&type=template&id=50d87c46&"
import script from "./ProxyErrors.vue?vue&type=script&lang=ts&"
export * from "./ProxyErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports